import {Dispatch, SetStateAction} from 'react'

export interface CompletedBatchFiltersType {
  searchTerm?: string
  startDate?: string
  endDate?: string
  page: number
  timestamp?: string
}

export const initialBatchDetails: BatchDetails = {
  totalRecords: 0,
  invalidRecords: 0,
  validRecords: 0,
  totalAmount: '',
  payableAmount: '',
  batchTitle: '',
  reference: '',
  batchId: '',
  notificationEmail: ''
}

export interface Batch {
  id: string
  title: string
  itemsCompleted: number
  amount: string
  dateCreate: string
  dateEject: string
  items: number
  programmedPayment: string
  paymentMade: string
  status: string
}

interface BaseBatch {
  id: string
  currencyCode: string
  amount: string
  paidAmount: string
  reference: string
  additionalInfo: string
  creationDate: string
  resolutionDate: string
  totalRecords: number
  validRecords: number
  notificationEmail?: string
}

export interface BatchUnscheduled extends BaseBatch {
  status: string
}

export interface BatchCompleted extends BaseBatch {
  title: string
  scheduledDate: string
  formattedCreationDate: string
  formattedScheduledDate: string
  creationUser: {
    id: string
  }
  status: string
}

export interface BatchError extends BaseBatch {
  title: string
  creationUser: {
    id: string
    name: string
    username: string
  }
  scheduledDate: string
  status: string
  errorMessage: string
}

export interface BatchDetails {
  totalRecords: number
  invalidRecords: number
  validRecords: number
  totalAmount: string
  payableAmount: string
  batchId: string
  batchTitle: string
  reference: string
  notificationEmail?: string
}

export interface DetailBatchRecord {
  name: string
  username: string
  amount: string
  reference: string
  description: string
  status: string
  phoneNumber: string
  errorMessage?: string
}

export type ListViewContextProps = {
  batchForUpdate?: BatchCompleted | undefined
  setBatchForUpdate: Dispatch<SetStateAction<BatchCompleted | undefined>>
  batchForCancel?: BatchCompleted | undefined
  setBatchForCancel: Dispatch<SetStateAction<BatchCompleted | undefined>>
}

export const initialListView: ListViewContextProps = {
  setBatchForUpdate: () => {},
  setBatchForCancel: () => {},
}
